// LQC-1704 — Cover (Advise Cover / releaseCover) and Cover Spread
// (releaseCoverSpread) settings only make sense when the OP is sending the
// trade to MORE THAN ONE counterparty. With a single CP there is nothing to
// "cover" against, so both controls are disabled.
//
// This module is the single, pure source of truth for the rule — reused by the
// Select Panel (New), the Edit Panel (CPSettingsGrid / CPOverrideRows) and the
// left-rail slide-in (TradeSettingsCondensedGrid), plus the store action that
// resets stale values when the CP count drops.

// Shown on the disabled Cover / Cover Spread controls.
export const SINGLE_CP_COVER_TOOLTIP =
  "Trade must be sent to more than 1 counterparty to adjust";

// True when there is only a single (or no) active counterparty, so Cover /
// Cover Spread must be locked. The threshold is "fewer than 2 active CPs".
export function isCoverSettingLockedBySingleCP(activeCpCount: number): boolean {
  return activeCpCount < 2;
}
